const GAME_ACCESS_TYPES = {
    PUBLIC: 'public',
    PRIVATE: 'private',
}

export default GAME_ACCESS_TYPES
